import script from "./Macroeconomics.vue?vue&type=script&setup=true&lang=js"
export * from "./Macroeconomics.vue?vue&type=script&setup=true&lang=js"

import "./Macroeconomics.vue?vue&type=style&index=0&id=6b2311d2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b2311d2"]])

export default __exports__